import { clarity } from 'react-microsoft-clarity';
import { useEffect } from 'react';
import config from 'infra/config';
import { User } from 'core/features/auth/typings/user';

export function registerClarity(data: Partial<User>) {
    clarity.identify(data.id!, {
        id: data.id,
        nome: data.nome,
        email: data.email,
    });
}

export default function ClarityProvider({ children }: { children: React.ReactNode }) {

    useEffect(() => {
        clarity.init(config.clarity.key);
    }, []);

    return <>{children}</>;
}